import { useQuery } from '@tanstack/react-query'
import { getCanvases } from '../../../../../api/hooks/canvases/canvasApi'
import { getWorkspaceID } from '../../../../../utils'
import { useEffect, useRef, useState } from 'react'
import { setCanvasPolling } from '../../../../../store/actions/uiActions'
import { useDispatch, useSelector } from 'react-redux'
import { useToast } from '../../../../ui'

const MAX_POLLING_COUNT = 30

export const CanvasPolling = () => {
    const workspaceID = getWorkspaceID()
    const dispatch = useDispatch()
    const isPolling = useSelector((state) => state.ui.isCanvasPolling)

    const [count, setCount] = useState(0)
    const { data, isFetching } = useQuery({
        queryKey: ['canvases', workspaceID],
        queryFn: async () => {
            const response = await getCanvases()
            return Array.isArray(response) ? response : []
        },
        enabled: !!workspaceID && count <= MAX_POLLING_COUNT && isPolling,
        refetchInterval: isPolling ? 10000 : false,
    })
    const prevDataRef = useRef(null)
    const toast = useToast()

    useEffect(() => {
        if (isPolling) {
            toast.info('We are generating your canvas. This can take several minutes.')
            setCount(0)
        }
    }, [isPolling])

    useEffect(() => {
        if (isFetching || !isPolling) return

        if (count >= MAX_POLLING_COUNT) {
            dispatch(setCanvasPolling(false))
            toast.error('Failed to create canvas. Please try again.')
            setCount(0)
        } else {
            setCount((prev) => prev + 1)
            if (prevDataRef.current && prevDataRef.current.length < data.length) {
                toast.success('Canvas created successfully!')
                setTimeout(() => {
                    dispatch(setCanvasPolling(false))
                }, 300)
                setCount(0)
            } else {
                if (count > 0 && !prevDataRef.current) prevDataRef.current = data
            }
        }
    }, [isFetching])

    return null
}
